import React, { useState } from "react";
import Icon from "../../../components/AppIcon";

const JsonViewer = ({ data, level = 0, path = "" }) => {
  const [collapsed, setCollapsed] = useState({});

  const toggleCollapse = (key) => {
    setCollapsed((prev) => ({
      ...prev,
      [key]: !prev?.[key],
    }));
  };

  const renderValue = (value, key, currentPath) => {
    const fullPath = currentPath ? `${currentPath}.${key}` : key;

    if (value === null) {
      return <span className="text-muted-foreground">null</span>;
    }

    if (typeof value === "string") {
      return <span className="text-terminal-cyan">"{value}"</span>;
    }

    if (typeof value === "number") {
      return <span className="text-warning">{value}</span>;
    }

    if (typeof value === "boolean") {
      return <span className="text-primary">{value?.toString()}</span>;
    }

    if (Array.isArray(value)) {
      const isCollapsed = collapsed?.[fullPath];
      return (
        <div>
          <button
            onClick={() => toggleCollapse(fullPath)}
            className="inline-flex items-center space-x-1 text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon
              name={isCollapsed ? "ChevronRight" : "ChevronDown"}
              size={14}
            />
            <span>[</span>
          </button>
          {!isCollapsed && (
            <div className="ml-4 border-l border-border pl-4">
              {value?.map((item, index) => (
                <div key={index} className="flex items-start space-x-2 py-1">
                  <span className="text-muted-foreground text-sm font-source min-w-[20px]">
                    {index}:
                  </span>
                  <div className="flex-1">
                    {renderValue(item, index, `${fullPath}[${index}]`)}
                  </div>
                </div>
              ))}
            </div>
          )}
          {!isCollapsed && <span className="text-muted-foreground">]</span>}
          {isCollapsed && (
            <span className="text-muted-foreground">
              ] ({value?.length} items)
            </span>
          )}
        </div>
      );
    }

    if (typeof value === "object") {
      const isCollapsed = collapsed?.[fullPath];
      const keys = Object.keys(value);

      return (
        <div>
          <button
            onClick={() => toggleCollapse(fullPath)}
            className="inline-flex items-center space-x-1 text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon
              name={isCollapsed ? "ChevronRight" : "ChevronDown"}
              size={14}
            />
            <span>{"{"}</span>
          </button>
          {!isCollapsed && (
            <div className="ml-4 border-l border-border pl-4">
              {keys?.map((objKey) => (
                <div key={objKey} className="flex items-start space-x-2 py-1">
                  <span className="text-terminal-blue font-source">
                    "{objKey}":
                  </span>
                  <div className="flex-1">
                    {renderValue(value?.[objKey], objKey, fullPath)}
                  </div>
                </div>
              ))}
            </div>
          )}
          {!isCollapsed && <span className="text-muted-foreground">{"}"}</span>}
          {isCollapsed && (
            <span className="text-muted-foreground">
              {"}"} ({keys?.length} properties)
            </span>
          )}
        </div>
      );
    }

    return <span className="text-foreground">{String(value)}</span>;
  };

  return (
    <div className="font-source text-sm">
      {Object.keys(data)?.map((key) => (
        <div key={key} className="flex items-start space-x-2 py-1">
          <span className="text-terminal-blue font-medium">"{key}":</span>
          <div className="flex-1">{renderValue(data?.[key], key, "")}</div>
        </div>
      ))}
    </div>
  );
};

export default JsonViewer;
